module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout-footer', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_c('strong', [_vm._v("Copyright")]), _vm._v("\n\t\tFreshin - V1.1.0 © 2015-2021\n\t\t"), _c('b', [_vm._v("|")]), _vm._v(" "), _c('strong', [_vm._v("Powerby")]), _vm._v("\n\t\tFreshin Front-End Tech Group\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a05582f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/components/bottom_bar.vue
// module id = 2389
// module chunks = 1